{
  "remove": "הסר"
}
